import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot} from '@angular/router';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '~local/app/core/services/authentication.service';

export const loggedInGuard: CanActivateChildFn = ($childRoute: ActivatedRouteSnapshot, $state: RouterStateSnapshot) => {
    const authService = inject(AuthenticationService);
    const  router = inject(Router);
    return authService.isAuthorized$
        .pipe(
            map($ => {
                if (!$ /* && $route.outlet === 'primary' */) {
                    return router.parseUrl('/login?returnUrl=' + $state.url);
                }
                return $;
            }),
        );
}
